module.exports = __webpack_public_path__ + "static/media/quick.ec6bfd78.png";